// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605151133/js/" + chunkId + "." + {"44":"1a29c6e4","225":"7c8ebef1","481":"b1865225","486":"78cdd7a9","770":"d3f73776"}[chunkId] + ".0.42305898975910194.chunk.js";
};